function SEFIntro({ Attendee }) {
  //Find the number of values in Attendee, nested or not nested, that are red, green, blue, or amber
  function NumberOfValuesThatAreAColour(Colour) {
    let count = 0;
    Object.entries(Attendee).forEach(([key, value]) => {
      if (typeof value === "object") {
        Object.entries(value).forEach(([key2, value2]) => {
          if (value2 === Colour) {
            count++;
          }
        });
      } else {
        if (value === Colour) {
          count++;
        }
      }
    });
    return count;
  }

  //Find all nested values in Attendee that are red, green, blue, or amber and return the path
  function FindNestedValuesThatAreAColour(Colour) {
    let paths = [];
    function searchNested(obj, path) {
      Object.entries(obj).forEach(([key, value]) => {
        if (typeof value === "object") {
          searchNested(value, path + "." + key);
        } else {
          if (value === Colour) {
            paths.push(key);
          }
        }
      });
    }
    searchNested(Attendee, "Attendee");
    return paths;
  }

  let redCount = NumberOfValuesThatAreAColour("Red");
  let amberCount = NumberOfValuesThatAreAColour("Amber");
  let greenCount = NumberOfValuesThatAreAColour("Green");
  let blueCount = NumberOfValuesThatAreAColour("Blue");

  let topLevelColor = "";
  if (redCount > 0) {
    topLevelColor = "Red";
  } else if (amberCount > 0) {
    topLevelColor = "Amber";
  } else if (greenCount > 0) {
    topLevelColor = "Green";
  } else if (blueCount > 0) {
    topLevelColor = "Blue";
  }

  return (
    <div style={{ maxHeight: "100vh", overflow: "auto" }}>
      <h4>
        {" "}
        <h1>{topLevelColor}</h1>
        {redCount > 0 ? (
          <div style={{ border: "3px solid #D11212" }}>
            Red: {redCount} <br></br>
            {FindNestedValuesThatAreAColour("Red")
              .join(", ")
              .replaceAll("_", " ")}
            <br></br>
          </div>
        ) : null}
        {amberCount > 0 ? (
          <div style={{ border: "3px solid #F98007" }}>
            Amber: {amberCount} <br></br>
            {FindNestedValuesThatAreAColour("Amber")
              .join(", ")
              .replaceAll("_", " ")}
            <br></br>
          </div>
        ) : null}
        {greenCount > 0 ? (
          <div style={{ border: "3px solid #06862F" }}>
            Green: {greenCount} <br></br>
            {FindNestedValuesThatAreAColour("Green")
              .join(", ")
              .replaceAll("_", " ")}
            <br></br>
          </div>
        ) : null}
        {blueCount > 0 ? (
          <div style={{ border: "3px solid #0853B6" }}>
            Blue: {blueCount} <br></br>
            {FindNestedValuesThatAreAColour("Blue")
              .join(", ")
              .replaceAll("_", " ")}
            <br></br>
          </div>
        ) : null}
      </h4>
    </div>
  );
}

export default SEFIntro;
